// import Vue from "vue";
import Vuex from "vuex";

import AppSetting from "./modules_lib/appSetting";
import User from "./modules_lib/user";
import Market from "./modules_lib/market";
import Project from "./modules_lib/project";
import Product from "./modules_lib/product";
import Area from "./modules_lib/area";
import AreaInterest from "./modules_lib/areaInterest";
import CustomerUser from "./modules_lib/customerUser";

// Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    appSetting: AppSetting,
    user: User,
    market: Market,
    project: Project,
    product: Product,
    area: Area,
    areaInterest: AreaInterest,
    customerUser: CustomerUser
  }
});
